import TalentListPage from '../components/Talent/TalentListPage'

const Employees = () => {
  return (
    <>
      <title>Employees | Talent Service</title>
      <TalentListPage talentType="employee" defaultFilters={{ is_active: 'true', current_only: 'true' }} />
    </>
  )
}

export default Employees
